import React from 'react';
import './FlowStatusBar.css';

/**
 * Slim pinned bar under the chat header. Shows the current step (stepper dots),
 * whose turn it is, and the single primary action. Tapping the bar opens the
 * detailed bottom sheet. Role-tinted via `roleColorVar` (green rides / terracotta
 * packages).
 */
export default function FlowStatusBar({
  steps = [],
  activeIndex = 0,
  turnLabel = '',
  primaryAction = null,
  roleColorVar = '--color-role-ride',
  roleInkVar = null,
  onOpen,
}) {
  const style = { '--flow-role': `var(${roleColorVar})` };
  if (roleInkVar) style['--flow-role-ink'] = `var(${roleInkVar})`;

  const openIfHandler = () => {
    if (onOpen) onOpen();
  };

  return (
    <div
      className="flow-status-bar"
      data-testid="flow-status-bar"
      style={style}
      aria-label="Open flow details"
      tabIndex={onOpen ? 0 : undefined}
      onClick={openIfHandler}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onOpen) {
          e.preventDefault();
          openIfHandler();
        }
      }}
    >
      <div className="flow-stepper" aria-hidden="true">
        {steps.map((label, i) => (
          <span
            key={i}
            data-testid="flow-step-dot"
            className={`flow-step-dot ${i < activeIndex ? 'done' : i === activeIndex ? 'active' : 'pending'}`}
            title={label}
          />
        ))}
      </div>

      <span className="flow-turn-label">{turnLabel}</span>

      {primaryAction && (
        <button
          type="button"
          className="flow-primary-action"
          disabled={primaryAction.disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (primaryAction.onClick) primaryAction.onClick();
          }}
        >
          {primaryAction.label}
        </button>
      )}
    </div>
  );
}
